import { render, staticRenderFns } from "./FundTable-Positions.vue?vue&type=template&id=6339c1a3&scoped=true&"
import script from "./FundTable-Positions.vue?vue&type=script&lang=js&"
export * from "./FundTable-Positions.vue?vue&type=script&lang=js&"
import style0 from "./FundTable-Positions.vue?vue&type=style&index=0&id=6339c1a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6339c1a3",
  null
  
)

export default component.exports